/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Media start mode
 * @export
 */
export const DatabaseMediaStartMode = {
    Envelope: 'ENVELOPE',
    Click: 'CLICK'
} as const;
export type DatabaseMediaStartMode = typeof DatabaseMediaStartMode[keyof typeof DatabaseMediaStartMode];


export function DatabaseMediaStartModeFromJSON(json: any): DatabaseMediaStartMode {
    return DatabaseMediaStartModeFromJSONTyped(json, false);
}

export function DatabaseMediaStartModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseMediaStartMode {
    return json as DatabaseMediaStartMode;
}

export function DatabaseMediaStartModeToJSON(value?: DatabaseMediaStartMode | null): any {
    return value as any;
}

